<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-text">
  <!-- Basic use of a text field. -->
  <p *scText="rendering.fields.sample"></p>

  <!-- Advanced usage of text field. Turns off Sitecore editing, supports raw HTML, and has a CSS class on the wrapper -->
  <section
    *scText="rendering.fields.sample2; encode: false; editable: false"
    class="fw-bold"
    data-sample="other-attributes-pass-through"
  ></section>

  <div>Raw value (not editable): {{rawFieldValue}}</div>
</app-styleguide-specimen>
